// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"category_card_wrapper__1YuSt","not_post":"category_card_not_post__2KvfL","imgQuiz":"category_card_imgQuiz__pPhM8"};